import { useEffect, useRef } from 'react';
import { COLLAPSE_ANIMATION_DURATION, WIDTHS } from './constants';
import { Animated, Platform } from 'react-native';

export const useDrawerWidthAnimation = (isCollapsed: boolean) => {
    const widthAnimation = useRef<Animated.Value>(new Animated.Value(isCollapsed ? WIDTHS.collapsed : WIDTHS.expanded));

    useEffect(() => {
        if (!widthAnimation.current) return;

        Animated.timing(widthAnimation.current, {
            toValue: isCollapsed ? WIDTHS.collapsed : WIDTHS.expanded,
            duration: COLLAPSE_ANIMATION_DURATION,
            useNativeDriver: Platform.OS === 'web',
        }).start();
    }, [isCollapsed]);

    return widthAnimation;
};
